import { Plus } from "lucide-react";
import Fab from "./Fab";

interface CreateActionProps {
  onClick: () => void;
  /** Accessible name for both variants (the FAB is icon-only). */
  label: string;
  /** Extra classes for the sm+ header pill only. */
  className?: string;
}

/**
 * Page-level create action: a compact header pill from sm up and a floating
 * action button on phones (<sm). The pill shares the header row with the
 * page title, so keep labels short.
 */
export default function CreateAction({
  onClick,
  label,
  className,
}: CreateActionProps) {
  return (
    <>
      <button
        type="button"
        onClick={onClick}
        className={`btn-primary hidden sm:inline-flex items-center gap-2 px-4 ${className ?? ""}`}
      >
        <Plus className="h-4 w-4" aria-hidden="true" />
        {label}
      </button>
      <Fab onClick={onClick} label={label} />
    </>
  );
}
